import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportShareResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportShareInner() {
    return <PlayerLevelReportBase tab="share" columnsSettingsViewType="PlayerLevelReportShare" />;
}

const PlayerLevelReportShareWithAccess = withAccessCheck(PlayerLevelReportShareInner, playerLevelReportShareResource);

export const PlayerLevelReportShare = withTraceErrorBoundary(PlayerLevelReportShareWithAccess, ErrorModal);
